/** Buckets phase media into images / guidelines / boq (category + filename fallbacks). */
export function organizePhaseDocumentsFromMedia(mediaArray) {
  const organized = { images: [], guidelines: [], boq: [] };
  (Array.isArray(mediaArray) ? mediaArray : []).forEach((item) => {
    const category = item.category || item.mediaType || item.type || item.media_type;
    const contentType = String(item.contentType || item.content_type || '');
    const fileKey = item.key || '';
    const fileName = item.name || fileKey.split('/').pop() || '';

    if (
      contentType.startsWith('image/') ||
      category === 'images' ||
      category === 'image' ||
      item.isImage
    ) {
      organized.images.push(item);
    } else if (
      category === 'guidelines' ||
      category === 'guideline' ||
      category === 'interior_design_guidelines' ||
      item.isGuidelines
    ) {
      organized.guidelines.push(item);
    } else if (
      category === 'boq' ||
      category === 'rera_boq_document' ||
      category === 'rera_boq' ||
      item.isBoq
    ) {
      organized.boq.push(item);
    } else {
      const lowerFileName = fileName.toLowerCase();
      const lowerFileKey = fileKey.toLowerCase();
      if (
        lowerFileName.includes('guideline') ||
        lowerFileName.includes('design') ||
        lowerFileName.includes('interior') ||
        lowerFileKey.includes('guideline') ||
        lowerFileKey.includes('interior')
      ) {
        organized.guidelines.push(item);
      } else if (
        lowerFileName.includes('boq') ||
        lowerFileName.includes('rera') ||
        lowerFileKey.includes('boq') ||
        lowerFileKey.includes('rera')
      ) {
        organized.boq.push(item);
      } else if (
        contentType &&
        (contentType.includes('pdf') ||
          contentType.includes('doc') ||
          contentType.includes('word'))
      ) {
        organized.guidelines.push(item);
      }
    }
  });
  return organized;
}
